import React from 'react'
import { AddPhotoAlternateOutlined } from '@material-ui/icons'
import { CustomTextFieldOrigin } from '../CustomTextFieldOrigin'
import { messages } from '../../config/messages'

interface IPastedImageField {
  disabled?: boolean
  onFileUpload: ([File]) => void
  onError: (message: string) => void
}

export const PastedImageField = ({
  disabled,
  onFileUpload,
  onError,
}: IPastedImageField) => {
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
    const copiedImage =
      e.clipboardData &&
      [...e.clipboardData.items].find(({ type }) => type.startsWith('image/'))
    const copiedImageInstance = copiedImage?.getAsFile()
    if (copiedImageInstance) {
      onFileUpload([copiedImageInstance])
    } else {
      onError(messages.notAnImageError)
    }
    e.preventDefault()
  }
  return (
    <CustomTextFieldOrigin
      name="pasteImage"
      label="Add a copied image"
      placeholder="Paste image"
      disabled={disabled}
      InputProps={{
        endAdornment: (
          <AddPhotoAlternateOutlined
            color={disabled ? 'disabled' : 'primary'}
          />
        ),
      }}
      onPaste={handlePaste}
    />
  )
}
